// extracted by mini-css-extract-plugin
module.exports = {"action-box":"index__action-box__2jKfk","action-content":"index__action-content__2M_5G"};